<template>
  <div class="solution-content" :class="{ hidden: !isActive }">
    <div class="solution-image">
      <img :src="item.image">
    </div>
    <h5 class="solution-heading wwf-font">{{ item.title }}</h5>
    <div class="solution-text">
      <p>{{ item.text }}</p>

      <div class="solution-links" ref="articles">
        <p v-for="(copy, i) in item.content" :key="'copy' + i">
          <span class="copy-text" v-html="copy"></span>
        </p>
      </div>
      
      <div class="solution-readmore">
        <a class="wwf-font" @click="handleClick">Learn more <i class="fas fa-chevron-right"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionsContent",

  props: {
    item: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
    },
  },

  mounted() {
    // Attach amplitude event to hyperlinks in copy
    try {
      const contentLink = this.$refs.articles.querySelector(".copy-text a");
      if (contentLink) {
        this.$refs.articles.querySelector(".copy-text a")
          .addEventListener("click", this.handleClick)
      }
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    handleClick() {
      this.$store.dispatch('logTabAction', {
        name: this.item.name,
        link: this.item.readMoreLink
      })
      .then(() => window.location.href = this.item.readMoreLink);
    }
  }
};
</script>

<style scoped>
.solution-content {
  display: grid;
  grid-template: auto 1fr / 1fr 3fr;
  gap: 1rem;
  padding: 1rem 1rem 2rem;
  background: var(--wwfGreyED);
}

.solution-heading {
  margin: 0;
  font-size: 1.5rem;
}

.solution-text {
  grid-column: span 2;
}

.solution-links {
  display: grid;
  grid-template: repeat(3, auto) / 1fr;
  gap: 1rem;
  margin-top: 1rem;
}

.solution-links a {
  border-radius: 4px;
  overflow: hidden;
}

.solution-links span {
  display: block;
  padding: 0.5rem 0;
}

.wwf-font {
  font-family: "WWF", sans-serif;
  font-weight: 400;
}

.solution-readmore {
  text-align: right;
  text-transform: uppercase;
  padding: 1rem 1rem 0;
}

.solution-readmore .wwf-font {
  font-size: 28px;
}

.copy-text >>> a {
  font-weight: bolder;
  color: var(--wwfBlack);
}

.hidden {
  display: none;
}

@media only screen and (min-width: 768px) {
  .solution-content {
    grid-column: 1 / -1;
    grid-row: -2;
    background: none;
  }

  .solution-image {
    grid-row: span 2;
  }

  .solution-text {
    grid-column: span 1;
  }

  .solution-links {
    grid-template: 1fr / repeat(3, 1fr);
  }
}

@media only screen and (min-width: 1200px) {
  .solution-content {
    gap: 2rem;
    padding-top: 3rem;
  }
  
  .solution-links {
    gap: 2rem;
    margin-top: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// SolutionsContent.vue?04c9e707